import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import { Typography } from '@mui/material';
// universe
import { UNIVERSE, UNIVERSE_FONT } from 'src/theme/universe/brand';

// ----------------------------------------------------------------------
// THE LEGAL LINE of the brand surfaces (DESIGN.md §2): who publishes the
// product and under which VAT number, at the foot of every sign-in screen and
// of the portal chooser (the owner, 2026-10-11: "© 2026 LINGOYOU UNIVERSE ·
// POWERED BY LINGOYOU GROUP S.R.L. · P. IVA 10145550967 · ALL RIGHTS
// RESERVED. ON EVERY LOGIN SCREEN AND ON ROOT LINK").
//
// It replaces the bare company name the sky used to carry. The words are
// written in sentence case and set in capitals by CSS, so the line reads as
// the owner wrote it while a screen reader says the words rather than
// spelling out capitals. The year is this year's, so January does not leave
// it a year behind. On the night, so it carries its own halo: on a short
// window it lands on the planet's lit limb.
// ----------------------------------------------------------------------

export const LEGAL_COMPANY = 'LingoYou Group S.r.l.';
export const LEGAL_VAT_NUMBER = '10145550967';

/** "© 2026 LingoYou Universe · Powered by LingoYou Group S.r.l. · P. IVA … · All rights reserved." */
export function legalLineText(year = new Date().getFullYear()) {
  return `© ${year} LingoYou Universe · Powered by ${LEGAL_COMPANY} · P. IVA ${LEGAL_VAT_NUMBER} · All rights reserved.`;
}

LegalLine.propTypes = {
  align: PropTypes.oneOf(['left', 'center']),
  sx: PropTypes.object
};

export default function LegalLine({ align = 'left', sx }) {
  return (
    <Typography
      component="p"
      sx={{
        m: 0,
        fontFamily: UNIVERSE_FONT,
        fontSize: 11,
        fontWeight: 500,
        lineHeight: 1.7,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        textAlign: align,
        // two even lines where it wraps, never a lone "RESERVED."
        textWrap: 'balance',
        // it sits on the limb, which is not black: 0.45 disappeared there
        color: alpha('#FFFFFF', 0.58),
        textShadow: `0 0 6px ${alpha(UNIVERSE.night, 0.9)}, 0 1px 2px ${alpha(
          UNIVERSE.night,
          0.8
        )}`,
        ...sx
      }}
    >
      {legalLineText()}
    </Typography>
  );
}
